import { render, staticRenderFns } from "./attributeMapp.vue?vue&type=template&id=845b38b4"
import script from "./attributeMapp.vue?vue&type=script&lang=js"
export * from "./attributeMapp.vue?vue&type=script&lang=js"
import style0 from "./attributeMapp.vue?vue&type=style&index=0&id=845b38b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports